export default "<body>\n  <!-- <div class=\"container\"> -->\n    <router-outlet></router-outlet>\n  <!-- </div> -->\n</body>\n"